import { BONUS_COVERS } from './assets'

export type Bonus = {
  number: string
  title: string
  body: string
  /** Mockup del bonus. null = card de portada diseñada en la landing. */
  cover: string | null
  meta: string
}

/** Los 5 bonus reales del pack (DPS46 - Bonus.docx). */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Printable Breath Card Deck',
    body: 'All 139 Breath Cards as summary cards — name, arc phase, Pace Dial, duration, the first Say it line and the safety flag. Print and cut them, or keep them on a tablet beside the mat, so you never flip through 300 pages mid-session.',
    cover: BONUS_COVERS['01'],
    meta: 'Printable · 139 cards',
  },
  {
    number: '02',
    title: 'See One Session, Start to Finish',
    body: 'A 90-minute 1:1 session told minute by minute: the screen, the intention, which card was used in each phase of the arc, what the facilitator said, when the Pace Dial came down and how it closed — with margin notes. A composite case, no real client data.',
    cover: BONUS_COVERS['02'],
    meta: 'Walk-through · ~5 pages',
  },
  {
    number: '03',
    title: 'The 7-Day Start Plan',
    body: 'Which volume and which pages to open each day of your first week, so by day 7 you have already run your first session from the pack. One page a day, a 7-box checklist and an “if you only have 20 minutes today” page.',
    cover: BONUS_COVERS['03'],
    meta: 'Plan · ~9 pages',
  },
  {
    number: '04',
    title: 'Find Your Facilitator Voice: 7 Rehearsal Drills',
    body: 'Seven short drills to rehearse the lines before you use them with people: saying the Say it aloud over music, holding the rhythm of the cues, lowering your volume without losing presence, and recording yourself with a self-listening checklist.',
    cover: BONUS_COVERS['04'],
    meta: 'Drills · ~9 pages',
  },
  {
    number: '05',
    title: 'Make It Yours: Using the Pack With Your Own Training',
    body: 'Trained in another connected breathwork lineage, or coming from yoga and pranayama? This guide shows which card fields to adjust — pattern, rhythm, touch, music, duration — so the pack fits your training, not the other way round. Plus a “My Lineage Settings” template.',
    cover: BONUS_COVERS['05'],
    meta: 'Guide · ~8 pages',
  },
]
